import { allowedWirelessTenants } from "config/wirelessWizard";

export const isWirelessTenantAllowed = (currentUserTenant: string): boolean =>
  allowedWirelessTenants.includes(currentUserTenant);
